import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
import { calculateRem } from '@uie/javascript-style-helpers';
import DropdownSelectMarketingTrigger from './DropdownSelectMarketingTrigger';
import DropdownSelectMarketingList from './DropdownSelectMarketingList';
import Icon, { IconData } from '@vds-core/icons';
import { colors, calculateSpacing } from '@vds-core/theme';
import { TypographyConfig } from '@vds-core/typography';
import { withVDSManager } from '@vds-core/utilities';
import cuid from 'cuid';
import { ErrorText, showError } from '@vds-core/form-elements';

function _calculateIconSpacing(size) {
  if (size === 'small') {
    return calculateSpacing('2X');
  } else {
    return calculateSpacing('1X');
  }
}

function _calculateErrorLabelSpacing(size) {
  if (size === 'large') {
    return calculateRem(3);
  } else if (size === 'small') {
    return calculateRem(1);
  } else {
    return calculateSpacing('1X');
  }
}

var _getIconColor = function _getIconColor(disabled, inverted, colors) {
  if (!inverted && !disabled) {
    return colors.black;
  } else if (disabled) {
    return inverted ? colors.coolGray10 : colors.coolGray3;
  } else {
    return colors.white;
  }
};

var propTypes = {
  /**
   * Items for the Dropdown List. Should use DropdownSelectOption.
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If true disables the dropdown component.
   */
  disabled: PropTypes.bool,

  /**
   * Boolean or a Function that returns a boolean value that determines if component should show the error state/error message. Function receives the 'event' object  on input change.
   */
  error: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

  /**
   * @deprecated errorText
   */
  errorMsg: PropTypes.string,

  /**
   * Message displayed when there is an error
   */
  errorText: PropTypes.string,

  /**
   * @deprecated
   */
  label: PropTypes.string,

  /**
   * Label for reading out meaningful text in aria-labels
   */
  hiddenLabel: PropTypes.string,

  /**
   * Placeholder text to be placed inside the dropdown select component that is displayed before a selection is made.
   */
  placeholder: PropTypes.string,

  /**
   * The width of the dropdown. If no width is passed small dropdowns with be 156px and large dropdowns with be 145px wide.
   */
  width: PropTypes.string,

  /**
   * The size of the entire dropdown.
   */
  size: PropTypes.oneOf(['large', 'normal', 'medium', 'small']),

  /**
   * The viewport that the dropdown styling should conform to.
   */
  viewport: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),

  /**
   * @ignore
   */
  color: PropTypes.object,

  /**
   * Selected item of the Dropdown List.
   */
  selected: PropTypes.string,

  /**
   * @ignore
   * string that sets the typescale for the typography (example: typescale === 'VDS')
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   * config for body typography
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   * config for title typography
   */
  titleConfig: PropTypes.object,

  /**
   * @ignore
   * if true, the caret-down icon changes to caret-up if this.state.open is also true
   */
  iconActiveState: PropTypes.bool,

  /**
   * @ignore
   * calculates the margin on top of the error text
   */
  calculateErrorLabelSpacing: PropTypes.func,

  /**
   * @ignore
   * calculates the padding next to the icon
   */
  calculateIconSpacing: PropTypes.func,

  /**
   * @ignore
   * adds additional hit area to the trigger
   */
  hitArea: PropTypes.bool,

  /**
   * @ignore
   * used to set padding underneath the trigger
   */
  triggerPaddingBottom: PropTypes.string,

  /**
   * @ignore
   * function that calculates the height of the drop down list item
   */
  calculateListItemHeight: PropTypes.func,

  /**
   * @ignore
   * function that calculates the padding inside of each list item
   */
  calculateListItemPadding: PropTypes.func,

  /**
   * @ignore
   * boolean that, if true, changes the hover states
   */
  hoverState: PropTypes.bool,

  /**
   * @ignore
   * boolean that, if true, changes the focus states
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   * passes through data for icons
   */
  iconConfig: PropTypes.object,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-level': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-position': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-datatrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-cta': PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * DropdownSelectMarketing will be displayed in Inverted colors if inverted prop is passed.
   */
  inverted: PropTypes.bool
};
var defaultProps = {
  className: null,
  disabled: false,
  error: undefined,
  size: 'normal',
  viewport: 'desktop',
  color: colors,
  selected: undefined,
  iconActiveState: false,
  calculateErrorLabelSpacing: _calculateErrorLabelSpacing,
  calculateIconSpacing: _calculateIconSpacing,
  hitArea: false,
  hoverState: false,
  focusState: false,
  typescale: TypographyConfig.getTypescale(),
  iconConfig: IconData,
  hiddenLabel: null,
  inverted: false
};
var selectWidth = 156;
var selectWidthSmallMobile = 166;
var DropdownWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "DropdownWrapper",
  componentId: "sc-1aqp0gl-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  outline: none;\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n"])), function (_ref) {
  var width = _ref.width;
  return width;
});
var IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-1aqp0gl-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  outline: none;\n  padding-left: ", ";\n"])), function (_ref2) {
  var calculateIconSpacing = _ref2.calculateIconSpacing,
      size = _ref2.size;
  return calculateIconSpacing(size);
});
var SelectedTextWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "SelectedTextWrapper",
  componentId: "sc-1aqp0gl-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n"])));

var Dropdown = /*#__PURE__*/function (_Component) {
  _inherits(Dropdown, _Component);

  var _super = _createSuper(Dropdown);

  function Dropdown(props) {
    var _this2;

    _classCallCheck(this, Dropdown);

    _this2 = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "componentDidUpdate", function (prevProps, prevState) {
      if ((!prevProps.selected || prevProps.selected !== _this2.props.selected) && _this2.props.selected) {
        _this2.setState({
          selectedOption: _this2.props.selected,
          open: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "componentDidMount", function () {
      document.addEventListener('click', _this2.handleClickOutside);
    });

    _defineProperty(_assertThisInitialized(_this2), "componentWillUnmount", function () {
      document.removeEventListener('click', _this2.handleClickOutside);
    });

    _defineProperty(_assertThisInitialized(_this2), "handleClickOutside", function (e) {
      if (_this2.triggerElem && !_this2.triggerElem.contains(e.target)) {
        _this2.setState({
          open: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "toggle", function (e) {
      _this2.setState({
        open: !_this2.state.open
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "_onKeyDown", function (e) {
      var key = e.keyCode;
      var entered = key === 13 || key === 32;
      var arrowed = key === 38 || key === 40;

      if (entered || arrowed) {
        _this2.setState({
          keyboardFocused: true
        });
      }

      if (arrowed) _this2.toggle();
    });

    _defineProperty(_assertThisInitialized(_this2), "setTriggerRef", function (element) {
      _this2.triggerElem = element;
    });

    _defineProperty(_assertThisInitialized(_this2), "_getIconSize", function (size, viewport, iconActiveState) {
      if (!iconActiveState) {
        switch (size) {
          case 'normal':
            return 15;

          case 'large':
            return 'medium';

          case 'small':
          case 'medium':
          default:
            return 'extraSmall';
        }
      } else {
        if ((viewport === 'desktop' || viewport === 'tablet') && size === 'large') {
          return 'large';
        } else if (viewport === 'mobile' && size === 'large') {
          return 'medium';
        } else if ((viewport === 'desktop' || viewport === 'tablet') && size === 'small') {
          return 'small';
        } else return 'extraSmall';
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "_onSelect", function (e) {
      _this2.setState({
        open: false
      });

      _this2.props.onSelect && _this2.props.onSelect(e);

      _this2.triggerElem.focus();

      var _this = _assertThisInitialized(_this2);

      showError(e, _this);
    });

    _defineProperty(_assertThisInitialized(_this2), "_getWidth", function (size, width, viewport) {
      if (width) return width;
      return size !== 'small' ? calculateRem(selectWidth) : viewport === 'mobile' ? calculateRem(selectWidthSmallMobile) : calculateRem(selectWidth);
    });

    _defineProperty(_assertThisInitialized(_this2), "_getAriaLabel", function () {
      if (_this2.props.hiddenLabel && _this2.state.selectedOption) {
        return _this2.state.selectedOption + 'selected from ' + _this2.props.hiddenLabel;
      } else if (!_this2.props.hiddenLabel && _this2.state.selectedOption) {
        return _this2.state.selectedOption + 'selected from dropdown select';
      } else if (_this2.props.hiddenLabel && !_this2.state.selectedOption) {
        return _this2.props.hiddenLabel;
      } else return 'dropdown select';
    });

    _defineProperty(_assertThisInitialized(_this2), "refKey", UNSAFE_SetEnvRef());

    _defineProperty(_assertThisInitialized(_this2), "_blurTrigger", function () {
      _this2.triggerElem.blur();
    });

    _defineProperty(_assertThisInitialized(_this2), "_blurList", function () {
      _this2.setState({
        keyboardFocused: false
      });
    });

    _this2.state = {
      open: false,
      selectedOption: _this2.props.selected || undefined,
      keyboardFocused: false,
      error: _this2.props.error === true
    };
    return _this2;
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _React$createElement2;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disabled = _this$props.disabled,
          inverted = _this$props.inverted,
          errorProp = _this$props.error,
          errorMsg = _this$props.errorMsg,
          errorText = _this$props.errorText,
          label = _this$props.label,
          placeholder = _this$props.placeholder,
          size = _this$props.size,
          color = _this$props.color,
          width = _this$props.width,
          viewport = _this$props.viewport,
          selected = _this$props.selected,
          iconConfig = _this$props.iconConfig,
          hitArea = _this$props.hitArea,
          hoverState = _this$props.hoverState,
          focusState = _this$props.focusState,
          typescale = _this$props.typescale,
          triggerPaddingBottom = _this$props.triggerPaddingBottom,
          calculateErrorLabelSpacing = _this$props.calculateErrorLabelSpacing,
          calculateIconSpacing = _this$props.calculateIconSpacing,
          calculateListItemHeight = _this$props.calculateListItemHeight,
          calculateListItemPadding = _this$props.calculateListItemPadding,
          iconActiveState = _this$props.iconActiveState,
          bodyConfig = _this$props.bodyConfig,
          titleConfig = _this$props.titleConfig,
          id = _this$props.id,
          analyticsTrack = _this$props['data-analyticstrack'],
          track = _this$props['data-track'],
          clickStream = _this$props['data-clickstream'],
          cta = _this$props['data-sitecat-cta'],
          dataTrack = _this$props['data-sitecat-datatrack'],
          position = _this$props['data-sitecat-position'],
          level = _this$props['data-sitecat-level'],
          hiddenLabel = _this$props.hiddenLabel;
      var error = this.state.error || typeof errorProp === 'boolean' && errorProp;
      var errorMessage = errorMsg ? errorMsg : errorText;
      var selectedOption = this.state.selectedOption || (label ? label : placeholder ? placeholder : '');

      var iconSize = this._getIconSize(size, viewport, iconActiveState);

      var selectWidth = this._getWidth(size, width, viewport);

      var itemId = cuid();
      var selectedOptionId = "selected".concat(cuid());
      error && !errorMessage && console.error('Error Text for DropdownSelectMarketing MUST be provided');
      return /*#__PURE__*/React.createElement(DropdownWrapper, {
        tabIndex: -1,
        id: id,
        className: className,
        width: selectWidth
      }, /*#__PURE__*/React.createElement(DropdownSelectMarketingTrigger, {
        triggerPaddingBottom: triggerPaddingBottom,
        hitArea: hitArea,
        focusState: focusState,
        bodyConfig: bodyConfig,
        titleConfig: titleConfig,
        typescale: typescale,
        onClick: this.toggle,
        onKeyDown: this._onKeyDown,
        disabled: disabled,
        inverted: inverted,
        error: error,
        size: size,
        viewport: viewport,
        selected: selected,
        setTriggerRef: this.setTriggerRef,
        "data-clickstream": clickStream,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-sitecat-cta": cta,
        "data-sitecat-level": level,
        "data-sitecat-position": position,
        "data-sitecat-datatrack": dataTrack,
        tabIndex: 0,
        "aria-expanded": this.state.open,
        "aria-label": this._getAriaLabel(),
        listId: itemId
      }, /*#__PURE__*/React.createElement(SelectedTextWrapper, {
        id: selectedOptionId
      }, selectedOption), /*#__PURE__*/React.createElement(IconWrapper, {
        size: size,
        viewport: viewport,
        calculateIconSpacing: calculateIconSpacing
      }, /*#__PURE__*/React.createElement(Icon, _defineProperty({
        size: size,
        viewport: viewport,
        iconActiveState: iconActiveState,
        tabIndex: -1,
        data: iconConfig,
        name: this.state.open ? 'caret-up' : 'caret-down',
        ariaHidden: true,
        color: _getIconColor(disabled, inverted, color)
      }, "size", iconSize)))), this.state.open && /*#__PURE__*/React.createElement(DropdownSelectMarketingList, (_React$createElement2 = {
        width: selectWidth,
        keyboardFocused: this.state.keyboardFocused,
        onSelect: this._onSelect,
        selectedOption: this.props.selectedOption,
        size: size,
        viewport: viewport,
        titleConfig: titleConfig,
        bodyConfig: bodyConfig,
        typescale: typescale,
        hoverState: hoverState,
        focusState: focusState,
        calculateListItemHeight: calculateListItemHeight,
        calculateListItemPadding: calculateListItemPadding,
        color: color,
        error: error,
        inverted: inverted
      }, _defineProperty(_React$createElement2, "viewport", viewport), _defineProperty(_React$createElement2, "toggleList", this.toggle), _defineProperty(_React$createElement2, "itemId", itemId), _defineProperty(_React$createElement2, "trigger", this.triggerElem), _defineProperty(_React$createElement2, "onClick", this._blurTrigger), _defineProperty(_React$createElement2, "onBlur", this._blurList), _defineProperty(_React$createElement2, "aria-labelledby", selectedOptionId), _defineProperty(_React$createElement2, "aria-activedescendant", selectedOptionId), _defineProperty(_React$createElement2, "tabIndex", -1), _React$createElement2), children), error && errorMessage && !disabled && !this.state.open && /*#__PURE__*/React.createElement(ErrorText, {
        errorLabelSpacing: calculateErrorLabelSpacing(size),
        bodyConfig: bodyConfig,
        typescale: typescale,
        errorText: errorMessage,
        error: error,
        color: color,
        inverted: inverted
      }));
    }
  }]);

  return Dropdown;
}(Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
export default withVDSManager(Dropdown);